import Vue from 'vue'

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from 'vee-validate'
import { required, email, min } from 'vee-validate/dist/rules'
import InquiryForm from '../vue/components/inquiryForm.vue'

export default {
  init() {
    extend('required', { ...required })
    extend('email', { ...email })
    extend('min', min)

    Vue.component('ValidationProvider', ValidationProvider)
    Vue.component('ValidationObserver', ValidationObserver)
    new Vue({
      el: '.main-content',
      components: { InquiryForm },
    })
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
}
